export default __webpack_public_path__ + "static/media/timer.3d31bd0e.svg";